import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'

import { showAlert } from '../alert/alert'
import getString from '../../config/strings'
import UserService from '../../services/userService'

import { USER_SCOPES, MIN_PASSWORD_SIZE, PASSWORD_SPECIAL_CHARS } from '../../config/config'

const styles = theme => ({
  button: {
    margin: theme.spacing(1)
  },
})

class ResetPassword extends PureComponent {
  constructor (props) {
    super(props)

    // props.match.params.token
    // props.match.params.signature

    this.emptyValues = {
      password: {
        value: '',
        error: false,
        message: ''
      },

      password2: {
        value: '',
        error: false,
        message: ''
      },
    }

    this.state = Object.assign({}, this.emptyValues)
  }

  validatePassword (value) {
    let hasUpperCase = value !== value.toLowerCase()  // mindestens ein Großbuchstabe
    let hasLowerCase = value !== value.toUpperCase()  // mindestens ein Kleinbuchstabe
    let hasDigit = value.match(/\d/)                  // mindestens eine Ziffer
    let hasSpecialChar = false
    for (let i = 0, l = PASSWORD_SPECIAL_CHARS.length; i < l; i++) {
      if (value.indexOf(PASSWORD_SPECIAL_CHARS.charAt(i)) >= 0) {
        hasSpecialChar = true
        break
      }
    } // mindestens ein Sonderzeichen
    return (hasUpperCase && hasLowerCase && hasDigit && hasSpecialChar)
  }

  setPassword (password) {
    password = password.replace(/^\s+/g, '')
    if (password.length >= MIN_PASSWORD_SIZE) {
      if (this.validatePassword(password)) {
        this.setState({ password: { value: password, error: false, message: '' } })
        if (this.state.password2.value)
          this.setPassword2(this.state.password2.value)
      } else {
        this.setState({ password: { value: password, error: true, message: getString('ERROR_PASSWORD_POLICY') } })
      }
    } else {
      this.setState({ password: { value: password, error: true, message: getString('ERROR_PASSWORD_SHORT') } })
    }
  }

  setPassword2 (password2) {
    password2 = password2.replace(/^\s+/g, '')
    if (password2.length >= MIN_PASSWORD_SIZE) {
      if (this.validatePassword(password2)) {
        if (password2 === this.state.password.value) {
          this.setState({ password2: { value: password2, error: false, message: '' } })
        } else {
          this.setState({ password2: { value: password2, error: true, message: getString('ERROR_PASSWORD_NOTMATCH') } })
        }
      } else {
        this.setState({ password2: { value: password2, error: true, message: getString('ERROR_PASSWORD_POLICY') } })
      }

    } else {
      this.setState({ password2: { value: password2, error: true, message: getString('ERROR_PASSWORD_SHORT') } })
    }
  }

  async resetPassword (event) {
    event.preventDefault()

    if (this.state.password.error || this.state.password2.error) {
      showAlert(getString('invalid inputs'), getString('RESET_ERROR'))
    } else {
      try {

        let response = await UserService.resetPassword(this.props.match.params.token, this.props.match.params.signature, this.state.password.value)

        const email = response.user.additionalData.nickName
        const password = this.state.password.value

        let auth = await UserService.login(email, password, USER_SCOPES)
        this.setState(Object.assign({}, this.emptyValues))
        this.props.parent.setLogin(auth)
        let self = this
        showAlert(getString('RESET_SUCCESS_TEXT'),
          getString('RESET_SUCCESS_TITLE'),
          [{ label: getString('OK'), callback: () => {self.props.history.replace('/')} }])
      } catch (error) {
        showAlert(getString(error.message), getString('RESET_ERROR'))
      }
    }
  }

  render () {
    return (
      <div className="App-content">
        <div>
          <Dialog
            open={true}
            aria-labelledby="form-dialog-title"
          >
            <form onSubmit={(event) => {this.resetPassword(event)}}>
              <DialogTitle
                id="form-dialog-title">{getString('PASSWORD_RESET')}</DialogTitle>
              <DialogContent>
                <TextField
                  margin="dense"
                  id="password"
                  label={getString('PASSWORD')}
                  required={true}
                  type="password"
                  error={this.state.password.error}
                  helperText={this.state.password.message}
                  onChange={(event) => {this.setPassword(event.target.value)}}
                  value={this.state.password.value}
                  fullWidth
                />
                <TextField
                  margin="dense"
                  id="password2"
                  label={getString('PASSWORD2')}
                  required={true}
                  type="password"
                  error={this.state.password2.error}
                  helperText={this.state.password2.message}
                  onChange={(event) => {this.setPassword2(event.target.value)}}
                  value={this.state.password2.value}
                  fullWidth
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={() => {
                  this.setState(Object.assign({}, this.emptyValues))
                  this.props.history.replace('/')
                }}
                        color="secondary">
                  {getString('CANCEL')}
                </Button>
                <Button type='submit' color="primary" variant="contained" size="small">
                  {getString('SAVE_PASSWORD')}
                </Button>
              </DialogActions>
            </form>
          </Dialog>
        </div>
      </div>
    )
  }
}

ResetPassword.propTypes = {
  classes: PropTypes.object.isRequired,
  parent: PropTypes.object.isRequired
}

export default withStyles(styles)(ResetPassword)
